<template>
  <div class="container-fluid">
    <!--    <Breadcrumbs main="Starter Kit" />-->

    <div class="row starter-main">
      <div class="col-sm-12">
        <div class="card" style="margin-top: 20px">
          <table v-if="list" class="table">
            <thead>
              <tr>
                <th scope="col" style="text-align: center">No.</th>
                <th scope="col" style="width: 400px">
                  Key Performance Indicator
                </th>
                <th scope="col">Weight</th>
                <th scope="col">Unit</th>
                <th scope="col">2024 Target</th>
                <th scope="col">YTD Target</th>
                <th scope="col">YTD Realization</th>
                <th scope="col">Achievement (%)</th>
                <th scope="col">Value</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody v-for="(item, id) in dataContract" :key="id">
              <tr
                v-if="
                  item.achievement === null &&
                  item.weight !== null &&
                  item.metricId !== 'MANAGEMENT_CONTRACT_TOTAL'
                "
              >
                <th style="background-color: #d1dfe5; text-align: center">
                  {{ item.numberId }}
                </th>
                <td colspan="1" style="background-color: #d1dfe5">
                  {{ item.metricName }}
                </td>
                <td colspan="6" style="background-color: #d1dfe5">
                  {{ item.weight }}
                </td>
                <td colspan="2" style="background-color: #d1dfe5">
                  {{ item.value }}
                </td>
                <td colspan="1" style="background-color: #d1dfe5"></td>
              </tr>
              <tr v-if="item.achievement === null && item.weight === null">
                <th style="background-color: #f6faff"></th>
                <td colspan="9" style="background-color: #f6faff">
                  {{ item.metricName }}
                </td>
              </tr>
              <tr v-if="item.achievement !== null && item.color !== null">
                <th>{{ item.numberId }}</th>
                <td>{{ item.metricName }}</td>
                <td>{{ item.weight }}</td>
                <td>{{ item.unit }}</td>
                <td>{{ item.valueTarget }}</td>
                <td>{{ item.ytdTarget }}</td>
                <td>{{ item.ytdRealization }}</td>
                <td>{{ item.achievement }}</td>
                <td>{{ item.value }}</td>
                <td v-if="item.color === 'green'">
                  <img src="@/assets/images/green_o.svg" />
                </td>
                <td v-if="item.color === 'red'">
                  <img src="@/assets/images/red_o.svg" />
                </td>
                <td v-if="item.color === 'gray'">
                  <img src="@/assets/images/grey_o.svg" />
                </td>
                <td v-if="item.color === 'orange'">
                  <img src="@/assets/images/orange_o.svg" />
                </td>
              </tr>
              <tr
                v-if="
                  item.achievement === null &&
                  item.weight !== null &&
                  item.metricId === 'MANAGEMENT_CONTRACT_TOTAL'
                "
                style="border-bottom-left-radius: 10px; color: white"
              >
                <td
                  colspan="2"
                  style="
                    background-color: #00a3e9;
                    border-bottom-left-radius: 10px;
                    color: white;
                  "
                >
                  Total
                </td>
                <td colspan="6" style="background-color: #00a3e9; color: white">
                  {{ item.weight }}
                </td>
                <td
                  colspan="1"
                  style="
                    background-color: #00a3e9;
                    border-bottom-right-radius: 10px;
                    color: white;
                  "
                >
                  {{ item.value }}
                </td>
                <td
                  colspan="1"
                  style="
                    background-color: #00a3e9;
                    border-bottom-right-radius: 10px;
                    color: white;
                  "
                ></td>
              </tr>
            </tbody>
            <tfoot></tfoot>
          </table>
          <div v-else class="card-body" style="background-color: #ebebeb">
            <div
              v-for="(item, id) in dataSummary"
              :key="id"
              class="row"
              style="margin-bottom: 5px"
            >
              <div style="display: flex">
                <div>
                  <div
                    :class="[
                      {
                        'orange-kpi': item.metricId === 'EKONOMI_SOSIAL',
                        'red-kpi': item.metricId === 'KEPEMIMPIAN_TEKNOLOGI',
                      },
                    ]"
                    class="kpi-card green-kpi"
                  >
                    <div
                      class="col-2"
                      style="
                        align-content: center;
                        font-size: 21px;
                        font-weight: 700;
                      "
                    >
                      {{ item.alphabet }}
                    </div>
                    <div
                      class="col"
                      style="
                        align-content: center;
                        padding: 8px;
                        font-size: 14px;
                        font-weight: 700;
                      "
                    >
                      {{ item.metricName }}
                    </div>
                    <div @click="onShowModalDetail(item)" class="button-more">
                      <div>More Details</div>
                    </div>
                    <!-- Modal -->
                    <div
                      class="modal fade"
                      id="modalA"
                      tabindex="-1"
                      aria-labelledby="exampleModalLabel"
                      aria-hidden="true"
                    >
                      <div class="modal-dialog modal-dialog-centered modal-xl">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5
                              class="modal-title"
                              id="exampleModalLabel"
                              style="padding-left: 5px; padding-right: 10px"
                            >
                              A
                            </h5>
                            <div>
                              <div>
                                Nilai Ekonomi dan Sosial untuk Indonesia
                              </div>
                              <div style="font-size: 12px; font-weight: 500">
                                Last Updated: 5 days ago
                              </div>
                            </div>
                            <div
                              class="card-header-right"
                              style="position: absolute; right: 50px"
                            >
                              <div class="row">
                                <div class="col">
                                  <div class="row">
                                    <!--                                    <div class="col"></div>-->
                                    <div
                                      class="col"
                                      style="font-weight: 500; color: #9f9f9f"
                                    >
                                      Polarity
                                    </div>
                                    <div
                                      class="col"
                                      style="font-weight: 500; display: flex"
                                    >
                                      <img
                                        src="@/assets/images/caret_up.svg"
                                        style="margin-right: 5px"
                                      />
                                      Maximize
                                    </div>
                                    <div
                                      class="col"
                                      style="font-weight: 500; display: flex"
                                    >
                                      <img
                                        src="@/assets/images/caret_down.svg"
                                        style="margin-right: 5px"
                                      />Minimize<i
                                        class="bi bi-caret-up-fill"
                                      ></i>
                                    </div>
                                    <div class="col">
                                      <span class="badge rounded-pill bg-danger"
                                        >< 95%</span
                                      >
                                    </div>
                                    <div class="col">
                                      <span
                                        class="badge rounded-pill bg-warning text-dark"
                                        >95-99%</span
                                      >
                                    </div>
                                    <div class="col">
                                      <span
                                        class="badge rounded-pill bg-success"
                                        >>=100%</span
                                      >
                                    </div>
                                    <div class="col">
                                      <span
                                        class="badge rounded-pill bg-light text-dark"
                                        >Not Started</span
                                      >
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <button
                              type="button"
                              class="btn-close"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            ></button>
                          </div>
                          <div class="modal-body">
                            <table class="table">
                              <thead>
                                <tr>
                                  <th scope="col">No.</th>
                                  <th scope="col" style="width: 400px">
                                    Key Performance Indicator
                                  </th>
                                  <th scope="col">Weight</th>
                                  <th scope="col">Unit</th>
                                  <th scope="col">2024 Target</th>
                                  <th scope="col">YTD Target</th>
                                  <th scope="col">YTD Realization</th>
                                  <th scope="col">Achievement (%)</th>
                                  <th scope="col">Value</th>
                                  <th scope="col"></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <th style="background-color: #f6faff"></th>
                                  <td
                                    colspan="9"
                                    style="background-color: #f6faff"
                                  >
                                    Finansial
                                  </td>
                                </tr>
                                <tr>
                                  <th>1</th>
                                  <td>EBITDA</td>
                                  <td>7</td>
                                  <td>Rp Triliun</td>
                                  <td>101.86</td>
                                  <td>5.05</td>
                                  <td>5.06</td>
                                  <td>100.28%</td>
                                  <td>7.01</td>
                                  <td>
                                    <img src="@/assets/images/green_o.svg" />
                                  </td>
                                </tr>
                                <tr>
                                  <th>2</th>
                                  <td>ROIC - WACC</td>
                                  <td>4</td>
                                  <td>%</td>
                                  <td>-1.25</td>
                                  <td>-2.89</td>
                                  <td>-2.65</td>
                                  <td>91.83%</td>
                                  <td>3.67</td>
                                  <td>
                                    <img src="@/assets/images/red_o.svg" />
                                  </td>
                                </tr>
                                <tr>
                                  <th>3</th>
                                  <td>Interest Bearing Debt to EBITDA</td>
                                  <td>6</td>
                                  <td>kali</td>
                                  <td>3.99</td>
                                  <td>6.63</td>
                                  <td>6.62</td>
                                  <td>100.28%</td>
                                  <td>6.01</td>
                                  <td>
                                    <img src="@/assets/images/green_o.svg" />
                                  </td>
                                </tr>
                                <tr>
                                  <th>4</th>
                                  <td>
                                    Interest Bearing Debt to Invested Capital
                                  </td>
                                  <td>6</td>
                                  <td>%</td>
                                  <td>28.4</td>
                                  <td>29.10</td>
                                  <td>28.45</td>
                                  <td>102.22%</td>
                                  <td>6.13</td>
                                  <td>
                                    <img src="@/assets/images/green_o.svg" />
                                  </td>
                                </tr>
                                <tr>
                                  <th>5</th>
                                  <td>
                                    Penyelesaian dan Penyampaian Laporan
                                    Keuangan Audit Tahun 2023
                                  </td>
                                  <td>4</td>
                                  <td>Hari Kerja</td>
                                  <td>5 (setelah SA 600 BPK final)</td>
                                  <td>-</td>
                                  <td>-</td>
                                  <td>-</td>
                                  <td>-</td>
                                  <td>
                                    <img src="@/assets/images/grey_o.svg" />
                                  </td>
                                </tr>
                                <tr>
                                  <th style="background-color: #f6faff"></th>
                                  <td
                                    colspan="9"
                                    style="background-color: #f6faff"
                                  >
                                    Operasional
                                  </td>
                                </tr>
                                <tr>
                                  <th>6</th>
                                  <td>Distribution Efficiency Rate</td>
                                  <td>5</td>
                                  <td>%</td>
                                  <td>8.51</td>
                                  <td>8.84</td>
                                  <td>8.84</td>
                                  <td>100%</td>
                                  <td>5.0</td>
                                  <td>
                                    <img src="@/assets/images/green_o.svg" />
                                  </td>
                                </tr>
                                <tr>
                                  <th style="background-color: #f6faff"></th>
                                  <td
                                    colspan="9"
                                    style="background-color: #f6faff"
                                  >
                                    Sosial
                                  </td>
                                </tr>
                                <tr>
                                  <th>7</th>
                                  <td>Rasio Elektrifikasi Nasional</td>
                                  <td>5</td>
                                  <td>%</td>
                                  <td>8.51</td>
                                  <td>8.84</td>
                                  <td>8.84</td>
                                  <td>100%</td>
                                  <td>5.0</td>
                                  <td>
                                    <img src="@/assets/images/green_o.svg" />
                                  </td>
                                </tr>
                                <tr>
                                  <th>8</th>
                                  <td>
                                    Penyelesaian Roadmap Energy Transition
                                    (Green RUPTL)
                                  </td>
                                  <td>3</td>
                                  <td>Tahapan/ Milestone</td>
                                  <td>Penyelesaian Dokumen RUPTL 2024-2033</td>
                                  <td>
                                    Update jadwal penyusunan Draft RUPTL
                                    2024-2033
                                  </td>
                                  <td>
                                    Update jadwal penyusunan Draft RUPTL
                                    2024-2033
                                  </td>
                                  <td>100%</td>
                                  <td>3.0</td>
                                  <td>
                                    <img src="@/assets/images/green_o.svg" />
                                  </td>
                                </tr>
                                <tr>
                                  <th>9</th>
                                  <td>Penyelesaian Program Dedieselisasi</td>
                                  <td>5</td>
                                  <td>Tahapan/ Milestone</td>
                                  <td>Penyelesaian Dokumen RKS Tahap 2</td>
                                  <td>-</td>
                                  <td>
                                    Persiapan penyusunan KKP (verifikasi usulan
                                    lokasi)
                                  </td>
                                  <td>-</td>
                                  <td>-</td>
                                  <td>
                                    <img src="@/assets/images/grey_o.svg" />
                                  </td>
                                </tr>
                                <tr>
                                  <th>10</th>
                                  <td>Penyelesaian Program Gasifikasi</td>
                                  <td>5</td>
                                  <td>Tahapan/ Milestone</td>
                                  <td>Pelaksanaan Konstruksi</td>
                                  <td>-</td>
                                  <td>Proses Pembahasan JDA</td>
                                  <td>-</td>
                                  <td>-</td>
                                  <td>
                                    <img src="@/assets/images/grey_o.svg" />
                                  </td>
                                </tr>
                              </tbody>
                              <tfoot>
                                <tr>
                                  <td
                                    colspan="2"
                                    style="background-color: #d1dfe5"
                                  >
                                    Overall
                                  </td>
                                  <td
                                    colspan="6"
                                    style="background-color: #d1dfe5"
                                  >
                                    50
                                  </td>
                                  <td
                                    colspan="2"
                                    style="background-color: #d1dfe5"
                                  >
                                    xx
                                  </td>
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                          <!--                          <div class="modal-footer">-->
                          <!--                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>-->
                          <!--                            <button type="button" class="btn btn-primary">Save changes</button>-->
                          <!--                          </div>-->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-for="(data, id) in item.listChild"
                  :key="id"
                  class="m-l-10"
                >
                  <div class="kpi-group-card">
                    <div style="display: block">
                      <div style="font-size: 12px; font-weight: 700">
                        {{ data.numberRange }}
                      </div>
                      <div style="font-size: 14px; font-weight: 500">
                        {{ data.metricName }}
                      </div>
                      <div
                        style="
                          position: absolute;
                          bottom: 12%;
                          font-size: 14px;
                          font-weight: 500;
                        "
                      >
                        <div style="display: flex">
                          <div
                            v-for="(color, id) in data.listColor"
                            :key="id"
                            style="margin: 2px"
                          >
                            <img
                              v-if="color === 'green'"
                              src="@/assets/images/green_o.svg"
                            />
                            <img
                              v-if="color === 'orange'"
                              src="@/assets/images/orange_o.svg"
                            />
                            <img
                              v-if="color === 'red'"
                              src="@/assets/images/red_o.svg"
                            />
                            <img
                              v-if="color === 'gray'"
                              src="@/assets/images/grey_o.svg"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- </div> -->
</template>
<script>
import ManagementContract from "@/services/management-contract/management-contract";

const apiContract = ManagementContract.build();
export default {
  components: {},
  data() {
    return {
      modalDetail: {
        show: false,
        load: false,
      },
      numeric: "",
      datas: "",
      titleDetail: "",
      modal: null,
      list: false,
      dataContract: [],
      resetCounter: 1,
      resetItemIds: [2],
      dataSummary: [],
    };
  },

  mounted() {
    this.$store.commit("updateJudulHalaman", "");
  },

  created() {
    this.getDataContract();
    this.getDataSummaryContract();
    this.getDataSummaryContractDetail();
  },

  methods: {
    onCloseModalDetail(value) {
      this.modalDetail.show = value;
    },
    onShowModalDetail(x) {
      this.titleDetail = x.metricName;
      this.datas = x.metricId;
      this.numeric = x.alphabet;
      this.modalDetail.show = true;
    },
    async getDataSummaryContract() {
      const res = await apiContract.getDataSummaryContract();
      const data = res.data.data;
      let alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

      data.forEach((obj, index) => {
        obj.alphabet = alphabet[index];
      });
      this.dataSummary = data;
    },
    async getDataSummaryContractDetail() {
      const param = {
        parentId: "EKONOMI_SOSIAL",
      };
      const res = await apiContract.getDataSummaryContractDetail(param);
      const data = res.data.data;
    },
    shouldResetNumber(item) {
      return item.achievement === null && item.weight === null;
    },
    resetNumber(x) {
      return this.resetCounter++;
    },
    async getDataContract() {
      const res = await apiContract.getDataContract();
      const data = res.data.data;
      const addData = this.addAlphabetProperty(data);
      this.dataContract = data;
    },

    addAlphabetProperty(array) {
      let alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

      array.forEach((obj, index) => {
        if (obj.metricId === "EKONOMI_SOSIAL") {
          obj.alphabet = "A";
        } else if (obj.metricId === "INOVASI_MODEL_BISNIS") {
          obj.alphabet = "B";
        } else if (obj.metricId === "KEPEMIMPIAN_TEKNOLOGI") {
          obj.alphabet = "C";
        } else if (obj.metricId === "PENINGKATAN_INVESTASI") {
          obj.alphabet = "D";
        } else if (obj.metricId === "PENGEMBANGAN_TALENTA") {
          obj.alphabet = "E";
        }
      });

      return array;
    },

    onShowModal() {
      this.modal.show();
    },

    changeView() {
      this.list = !this.list;
    },
  },
};
</script>
